var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    xmlSpace: "preserve",
    id: "iconmonstrlinktop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstrlinktop-bezier",
    stroke: "none",
    fill: "rgb(0, 122, 255)",
    d: "M 1.54,17.79 C 1.54,17.17 1.63,16.57 1.79,16 2.71,12.83 5.93,10.81 9.23,11.49 L 9.23,14.67 C 7.73,14.08 6.01,14.62 5.14,16 4.81,16.52 4.62,17.13 4.62,17.79 L 4.62,23.88 C 4.62,25.73 6.12,27.23 7.97,27.23 9.82,27.23 11.32,25.73 11.32,23.88 L 11.32,22 C 12.52,21.49 13.57,20.71 14.4,19.74 L 14.4,23.88 C 14.4,27.43 11.52,30.31 7.97,30.31 4.42,30.31 1.54,27.43 1.54,23.88 L 1.54,17.79 Z M 1.54,8.12 L 1.54,12.27 C 2.38,11.29 3.43,10.51 4.62,10 L 4.62,8.12 C 4.62,6.28 6.12,4.77 7.97,4.77 9.82,4.77 11.32,6.28 11.32,8.12 L 11.32,14.21 C 11.32,16.07 9.81,17.56 7.97,17.56 7.54,17.56 7.09,17.48 6.71,17.33 L 6.71,20.51 C 7.13,20.6 7.52,20.64 7.97,20.64 9.12,20.64 10.28,20.34 11.32,19.7 12.67,18.87 13.7,17.56 14.15,16 14.31,15.43 14.4,14.83 14.4,14.21 L 14.4,8.12 C 14.4,4.57 11.52,1.69 7.97,1.69 4.42,1.69 1.54,4.57 1.54,8.12 Z M 1.54,8.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTop);
export default __webpack_public_path__ + "static/media/link-top.7932a415b2f96b69ddb31d5b8d085a12.svg";
export { ForwardRef as ReactComponent };